import axios from "axios";
import { GetAllPoetDTO } from "../../dto";
import { plainToClass } from "class-transformer";
import { validate } from "class-validator";

type GetAllPoetProps = {
  page: number;
  pageSize: number;
  name?: string;
  nameOrder?: "ASC" | "DESC" | "";
};

let body: GetAllPoetDTO;

export async function getAllPoetAction(props: GetAllPoetProps) {
  const token = localStorage.getItem("token");

  const params = {
    page: props.page,
    pageSize: props.pageSize,
    name: props.name,
    nameOrder: props.nameOrder !== "" ? props.nameOrder : undefined,
  };

  return await axios
    .get(`${process.env.REACT_APP_API_ORIGIN}/1.0.0/cms/poets/get-all`, {
      headers: {
        "Content-Type": "application/json",
        "app-platform": "cms",
        Authorization: `Bearer ${token}`,
      },
      params,
    })
    .then(async (res) => {
      body = plainToClass(GetAllPoetDTO, res.data);
      const errors = await validate(body);

      if (errors.length > 0) {
        throw errors;
      }

      return res.data;
    });
}
